export default "__VITE_ASSET__RH53Z_nn__"